import { render, staticRenderFns } from "./wechatIndex.vue?vue&type=template&id=c7a313ba&scoped=true&"
import script from "./wechatIndex.vue?vue&type=script&lang=js&"
export * from "./wechatIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a313ba",
  null
  
)

export default component.exports